// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { NavigationBar } from '@/components/navigation-bar';
import { navigationSectionsConfig } from '@/constants/navigation-sections';
import { NavigationProvider } from '@/contexts/navigation-provider';
import { Box, CircularProgress, Stack, styled } from '@mui/material';
import { PropsWithChildren, ReactNode, Suspense } from 'react';

export const LoadingIndicator = styled(CircularProgress)({
  alignSelf: 'center',
  marginTop: 'auto',
  marginBottom: 'auto',
});

interface Props extends PropsWithChildren {
  /**
   * An optional full-width notice rendered above the navigation bar. It sits
   * outside the Suspense boundary so it paints before the page data resolves.
   */
  banner?: ReactNode;
}

export function NavigationLayout(props: Props) {
  return (
    <NavigationProvider navigationSections={navigationSectionsConfig}>
      <Box display="flex" flexDirection="column" width="100dvw" height="100dvh">
        {props.banner}
        <Suspense fallback={<LoadingIndicator />}>
          <NavigationBar />
          <Stack flexGrow={1} component="main" overflow="auto">
            {/* This is what catches the full-page loading state */}
            <Suspense fallback={<LoadingIndicator />}>
              {props.children}
            </Suspense>
          </Stack>
        </Suspense>
      </Box>
    </NavigationProvider>
  );
}
